module.exports = __webpack_public_path__ + "img/enkai-basic.bc1cfc6c.jpg";